import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchDriverCerts, getDriverRoute } from 'actions/profile'
import { ProfileVehicle } from 'types/profile'
import { initialModalOptions, ModalOptions } from 'types/global'

export const useDrivingInfoPageViewModel = () => {
  const isWebView = useSelector<any, boolean>((state) => state.config.isWebview)
  const vehicles = useSelector<any, ProfileVehicle[]>((state) => state.vehicles)
  const dispatch = useDispatch()

  const pendingVehicle = vehicles.find((v) => v.plate_lookup?.result === 'pending') ?? null
  const [modalOptions, setModalOptions] = useState<ModalOptions>(initialModalOptions)

  useEffect(() => {
    // TODO: what do we need the certs for here? can we remove this?
    fetchDriverCerts()(dispatch)
    getDriverRoute()(dispatch)
  }, [dispatch])

  useEffect(() => {
    if (pendingVehicle !== null) {
      setModalOptions({ modalOpen: true, modalType: 'pending-plate-lookup' })
    }
  }, [pendingVehicle])

  return {
    isWebView,
    pendingVehicle,
    modalOptions,
    setModalOptions,
  }
}
